import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-1f65ee9e")

_pushScopeId("data-v-1f65ee9e")
const _hoisted_1 = {
  key: 3,
  class: "p-menuitem-icon fas fa-file"
}
const _hoisted_2 = { class: "p-menuitem-text" }
const _hoisted_3 = {
  key: 4,
  class: "pi pi-fw pi-angle-right"
}
const _hoisted_4 = {
  key: 4,
  class: "p-menuitem-icon fas fa-file"
}
const _hoisted_5 = { class: "p-menuitem-text" }
const _hoisted_6 = {
  key: 5,
  class: "pi pi-fw pi-angle-right"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Badge = _resolveComponent("Badge")
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock("li", {
    role: "menu",
    style: [_ctx.item.style, _ctx.getVisibilityClass(_ctx.item)],
    title: _ctx.getInternationalizedValue()
  }, [
    (_ctx.item.to && !_ctx.item.disabled)
      ? (_openBlock(), _createBlock(_component_router_link, {
          key: 0,
          to: _ctx.cleanTo,
          custom: "",
          exact: ""
        }, {
          default: _withId(({ navigate, isActive }) => [
            _createVNode("a", {
              onClick: ($event: any) => (_ctx.onClick($event, navigate)),
              role: "menuitem",
              class: isActive && 'router-link-active'
            }, [
              (_ctx.badge > 0)
                ? (_openBlock(), _createBlock(_component_Badge, {
                    key: 0,
                    value: _ctx.badge,
                    severity: "danger"
                  }, null, 8, ["value"]))
                : _createCommentVNode("", true),
              (_ctx.item.iconCls)
                ? (_openBlock(), _createBlock("span", {
                    key: 1,
                    class: ['p-menuitem-icon', _ctx.item.iconCls]
                  }, null, 2))
                : _createCommentVNode("", true),
              (_ctx.item.custIcon)
                ? (_openBlock(), _createBlock("img", {
                    key: 2,
                    src: _ctx.item.custIcon
                  }, null, 8, ["src"]))
                : _createCommentVNode("", true),
              (!_ctx.item.iconCls && !_ctx.item.custIcon)
                ? (_openBlock(), _createBlock("span", _hoisted_1))
                : _createCommentVNode("", true),
              _createVNode("span", _hoisted_2, _toDisplayString(_ctx.getInternationalizedValue()), 1),
              (_ctx.item.items)
                ? (_openBlock(), _createBlock("i", _hoisted_3))
                : _createCommentVNode("", true)
            ], 10, ["onClick"])
          ]),
          _: 1
        }, 8, ["to"]))
      : (_openBlock(), _createBlock("a", {
          key: 1,
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onClick && _ctx.onClick(...args))),
          target: _ctx.item.target,
          role: "menuitem",
          tabindex: _ctx.item.disabled ? null : '0'
        }, [
          (_ctx.badge > 0)
            ? (_openBlock(), _createBlock(_component_Badge, {
                key: 0,
                value: _ctx.badge,
                severity: "danger"
              }, null, 8, ["value"]))
            : _createCommentVNode("", true),
          (_ctx.item.iconCls && _ctx.item.command != 'languageSelection')
            ? (_openBlock(), _createBlock("span", {
                key: 1,
                class: ['p-menuitem-icon', _ctx.item.iconCls]
              }, null, 2))
            : _createCommentVNode("", true),
          (_ctx.item.custIcon)
            ? (_openBlock(), _createBlock("img", {
                key: 2,
                src: _ctx.item.custIcon
              }, null, 8, ["src"]))
            : _createCommentVNode("", true),
          (_ctx.item.iconCls && _ctx.item.command === 'languageSelection')
            ? (_openBlock(), _createBlock("img", {
                key: 3,
                src: require('@/assets/images/flags/' + _ctx.locale.toLowerCase().substring(3, 5) + '.svg')
              }, null, 8, ["src"]))
            : _createCommentVNode("", true),
          (!_ctx.item.iconCls && !_ctx.item.custIcon)
            ? (_openBlock(), _createBlock("span", _hoisted_4))
            : _createCommentVNode("", true),
          _createVNode("span", _hoisted_5, _toDisplayString(_ctx.getInternationalizedValue()), 1),
          (_ctx.item.items)
            ? (_openBlock(), _createBlock("i", _hoisted_6))
            : _createCommentVNode("", true)
        ], 8, ["target", "tabindex"]))
  ], 12, ["title"]))
})